export const SkIdMessageType = {
    Pending: "PENDING",
    Pin: "PIN"
};

export const SkType = {
    MobileId: "Mobiil-ID",
    SmartId: "Smart-ID"
};
